import React from 'react';
import { useToggle } from '~/helpers/data';
import { TocOption, WebviewOption, PdfOption, BookshareOption, KindleOption, CheggOption, OptionExpander } from './get-this-title-files/options';
import OrderPrintCopy from './get-this-title-files/order-print-copy/order-print-copy';
import './get-this-title-files/get-this-title.scss';
import trackLink from './track-link';
function AdditionalOptions({ model }) {
    return (React.createElement(React.Fragment, null,
        React.createElement(BookshareOption, { model: model }),
        React.createElement(KindleOption, { model: model })));
}
export default function GetThisTitle({ model }) {
    const additionalOptions = ['bookshareLink', 'kindleLink'].filter((key) => model[key]).length;
    const [expanded, toggleExpanded] = useToggle(additionalOptions < 1);
    const interceptLinkClicks = React.useCallback((event) => {
        trackLink(event, model.id.toString());
    }, [model.id]);
    return (React.createElement("div", { className: "get-the-book" },
        React.createElement("div", { className: "get-this-title" },
            React.createElement("div", { className: "options", onClick: interceptLinkClicks, "data-analytics-nav": "Get the book" },
                React.createElement(TocOption, { model: model }),
                React.createElement(WebviewOption, { model: model }),
                React.createElement(PdfOption, { model: model }),
                React.createElement(CheggOption, { model: model }),
                expanded && React.createElement(AdditionalOptions, { model: model }),
                React.createElement(OptionExpander, { expanded, additionalOptions, toggle: toggleExpanded }))),
        React.createElement(OrderPrintCopy, { slug: model.slug })));
}
